export default __webpack_public_path__ + "static/media/quiz.eefaa120.png";